var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22889 11.2522C7.30889 15.34 10.66 18.6767 14.7478 20.7711L17.9256 17.5933C18.3156 17.2033 18.8933 17.0733 19.3989 17.2467C21.0167 17.7811 22.7644 18.07 24.5556 18.07C25.35 18.07 26 18.72 26 19.5144V24.5556C26 25.35 25.35 26 24.5556 26C10.9922 26 0 15.0078 0 1.44444C0 0.65 0.65 0 1.44444 0H6.5C7.29444 0 7.94444 0.65 7.94444 1.44444C7.94444 3.25 8.23333 4.98333 8.76778 6.60111C8.92667 7.10667 8.81111 7.67 8.40667 8.07444L5.22889 11.2522Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogo);
export default __webpack_public_path__ + "static/media/PhoneLogo.4c560609bb41eb65e27d1d0f2d69172d.svg";
export { ForwardRef as ReactComponent };